/**
 * Formats a number as a currency string with 2 decimal places
 * @param amount The amount to format
 * @returns Formatted currency string (e.g., "$12.50")
 */
export const formatCurrency = (amount: number): string => {
  return `$${amount.toFixed(2)}`;
};
